import React, { useEffect } from "react"
import PropTypes from "prop-types"
import rehypeReact from "rehype-react"
import hljs from "highlight.js/lib/core"
import shell from "highlight.js/lib/languages/shell"
import yaml from "highlight.js/lib/languages/yaml"
import bash from "highlight.js/lib/languages/bash"

import ImgSharpInline from "./ImgSharpInline"
import PostInlineCta from "./post-inline-cta/PostInlineCta"
import InlineScript from "./InlineScript"
import IframeEmbed from "./IframeEmbed"
import Table from "./article/Table"

const render = (htmlAst, rehypeComponents) => {
  const renderAst = new rehypeReact({
    Fragment: React.Fragment,
    createElement: React.createElement,
    components: {
      "img-sharp-inline": ImgSharpInline,
      "post-cta-inline": PostInlineCta,
      script: InlineScript,
      iframe: IframeEmbed,
      table: Table,
      ...rehypeComponents,
    },
    passNode: true,
  }).Compiler

  return renderAst(htmlAst)
}

const RenderContent = ({ htmlAst, html, rehypeComponents }) => {
  const post_body_ref = React.createRef()
  hljs.registerLanguage("shell", shell)
  hljs.registerLanguage("bash", bash)
  hljs.registerLanguage("yaml", yaml)

  useEffect(() => {
    if (post_body_ref) {
      const nodes = post_body_ref.current.querySelectorAll("pre")
      nodes.forEach(node => {
        hljs.highlightBlock(node)
      })
    }
  }, [post_body_ref])

  // replace all `ref=containous.ghost.io` with `ref=traefik.io`
  useEffect(() => {
    if (post_body_ref) {
      const nodes = post_body_ref.current.querySelectorAll("a")
      nodes.forEach(node => {
        if (node.href.includes("ref=containous.ghost.io")) {
          node.href = node.href.replace(
            "ref=containous.ghost.io",
            "ref=traefik.io",
          )
        }
      })
    }
  }, [post_body_ref])

  return (
    <React.Fragment>
      {htmlAst ? (
        <div
          className="load-external-scripts article-styles"
          ref={post_body_ref}
        >
          {render(htmlAst, rehypeComponents)}
        </div>
      ) : (
        <div
          className="load-external-scripts article-styles normal"
          dangerouslySetInnerHTML={{ __html: html }}
          ref={post_body_ref}
        />
      )}
    </React.Fragment>
  )
}

RenderContent.propTypes = {
  htmlAst: PropTypes.object,
  html: PropTypes.string.isRequired,
}

export default RenderContent
